/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const InOfficeIcon = createIcon({
  displayName: "InOfficeIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <rect
        x={0.75}
        y={0.75}
        width={14.5}
        height={14.5}
        rx={7.25}
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2786 5.53114L7.98836 10.8236C7.30488 11.5074 6.19644 11.5074 5.51297 10.8236L2.72168 8.03114L3.78256 6.9707L6.57385 9.76315C6.67149 9.86083 6.82984 9.86083 6.92748 9.76315L12.2177 4.4707L13.2786 5.53114Z"
        fill="currentColor"
      />
    </g>
  )
});
